"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TourStepSettingsModal = void 0;
const react_1 = require("@thesisedu/react");
const react_2 = __importDefault(require("react"));
function TourStepSettingsModal({ visible, onCancel, prefix }) {
    return (react_2.default.createElement(react_1.Modal, { title: 'Step Settings', visible: visible, onCancel: onCancel },
        react_2.default.createElement(react_1.VSpaced, { space: '@size-m' },
            react_2.default.createElement(react_1.Form.Item, { name: `${prefix}.postDelay`, label: 'Post Delay', extra: 'How many seconds should the tour wait before moving on to the next step once this one is complete?' },
                react_2.default.createElement(react_1.InputNumber, { min: 0, precision: 2, max: 10, style: { width: 150 } })),
            react_2.default.createElement(react_1.Form.Item, { name: `${prefix}.navigateTo`, label: 'Navigate', extra: 'If passed, this path will automatically be navigated to before this step begins. Param placeholders are automatically replaced.' },
                react_2.default.createElement(react_1.Input, { placeholder: '/classes/:classId/simulation/etc' })))));
}
exports.TourStepSettingsModal = TourStepSettingsModal;
//# sourceMappingURL=TourStepSettingsModal.js.map